export enum GrowthPlanStatus {
    SESSIONS_INCOMPLETE = 'SESSIONS_INCOMPLETE',
    SESSIONS_COMPLETE = 'SESSIONS_COMPLETE',
    GROWTH_PLAN_COMPLETE = 'GROWTH_PLAN_COMPLETE'
}